var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("VueCtkDateTimePicker", {
                attrs: {
                  id: "fecha_abono",
                  locale: "es",
                  "no-label": "",
                  "button-now-translation": "Ahora",
                  format: "YYYY-MM-DD HH:mm",
                  formatted: "YYYY-MM-DD HH:mm",
                  label: "Seleccione fecha..."
                },
                model: {
                  value: _vm.modelValue.fecha_abono,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "fecha_abono", $$v)
                  },
                  expression: "modelValue.fecha_abono"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de abono")]),
              _vm._v(" "),
              _vm.errores.fecha_abono
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.fecha_abono[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "valor_abono",
                  placeholder: "Escriba un valor..."
                },
                model: {
                  value: _vm.modelValue.valor_abono,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "valor_abono", $$v)
                  },
                  expression: "modelValue.valor_abono"
                }
              },
              [
                _vm._v("\n          Valor de abono\n          "),
                _vm.errores.valor_abono
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.valor_abono[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c("p", [
            _c("label", { attrs: { for: "cobro_oficina" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modelValue.cobro_oficina,
                    expression: "modelValue.cobro_oficina"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  name: "cobro_oficina",
                  id: "cobro_oficina"
                },
                domProps: {
                  checked: Array.isArray(_vm.modelValue.cobro_oficina)
                    ? _vm._i(_vm.modelValue.cobro_oficina, null) > -1
                    : _vm.modelValue.cobro_oficina
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.modelValue.cobro_oficina,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.modelValue,
                            "cobro_oficina",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.modelValue,
                            "cobro_oficina",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.modelValue, "cobro_oficina", $$c)
                    }
                  }
                }
              }),
              _c("span", [_vm._v("Cobro en oficina")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "textarea-field",
              {
                attrs: {
                  placeholder: "Escriba una observación...",
                  id: "observacion"
                },
                model: {
                  value: _vm.modelValue.observacion,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "observacion", $$v)
                  },
                  expression: "modelValue.observacion"
                }
              },
              [
                _c("span", [_vm._v("Observación")]),
                _vm._v(" "),
                _vm.errores.observacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.observacion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.guardar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _c("span", [_vm._v("Guardar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: { click: _vm.cancelar }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Abono de pedido")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-347c533e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347c533e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/AbonoPedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-347c533e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/AbonoPedido.vue
// module chunks = 0